import InstanceOverview from './InstanceOverview.container';

export default InstanceOverview;
